export default __webpack_public_path__ + "static/media/question.77a3ca4e.svg";